import { createFileRoute } from '@tanstack/react-router';
import { SalesHome } from '@/domains/sales/portal/SalesHome';

export const Route = createFileRoute('/_backoffice/sales/')({
    component: SalesHome,
});
